import type { BlogPost } from '@/types';

export const SITE_URL = 'https://javiercallico.me';
export const DEFAULT_DESCRIPTION = 'Javier Callico, Lead Software Engineer at Broadridge Financial Solutions. Software engineering, Azure, solution architecture, and open-source projects.';
export interface SeoOptions {
  image?: string | null;
  article?: BlogPost | null;
  noindex?: boolean;
}

export function createSeo(path: string, title?: string, description?: string, options: SeoOptions = {}) {
  const pathname = new URL(path, SITE_URL).pathname;
  const canonical = `${SITE_URL}${pathname === '/' ? '/' : pathname.replace(/\/+$/, '')}`;
  const fullTitle = title ? `${title} — Javier Callico` : 'Javier Callico — Software Engineer';
  const image = new URL(options.image || '/og-image.jpg', SITE_URL).href;
  const person = {
    '@type': 'Person', '@id': `${SITE_URL}/#person`, name: 'Javier Callico',
    url: SITE_URL, jobTitle: 'Lead Software Engineer',
    worksFor: { '@type': 'Organization', name: 'Broadridge Financial Solutions' },
    sameAs: ['https://github.com/JCallico', 'https://www.linkedin.com/in/jcallico/', 'https://x.com/jcallico'],
  };
  const article = options.article;
  const structuredData = article ? {
    '@context': 'https://schema.org', '@type': 'BlogPosting',
    headline: article.title, description: description || DEFAULT_DESCRIPTION,
    mainEntityOfPage: canonical, url: canonical, author: person,
    datePublished: article.createdAt, dateModified: article.updatedAt || article.createdAt,
    ...(article.featuredImage ? { image } : {}),
  } : {
    '@context': 'https://schema.org', '@type': pathname === '/about' ? 'ProfilePage' : 'WebPage',
    name: fullTitle, description: description || DEFAULT_DESCRIPTION, url: canonical,
    ...(pathname === '/about' || pathname === '/resume' ? { mainEntity: person } : { author: person }),
  };
  return { title: fullTitle, description: description || DEFAULT_DESCRIPTION, canonical, image,
    type: article ? 'article' : 'website', structuredData, noindex: Boolean(options.noindex) };
}

export function safeJson(value: unknown): string {
  return JSON.stringify(value).replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}
